import axios from 'axios';
import { handleIsOpenForm } from '../helpers/HandleIsOpenForm';
import CustomToast from '../Component/CustomToast/CustomToast';
import { toast } from 'react-toastify';

export const handleGetFormDetails = async ({
  id,
  status,
  token,
  setLoading,
  setError,
  setFormFullDetails,
  setDrawerData,
  setTitle,
  setEditMode,
  navigate,
  setPasswordModalOpen,
  setFormId,
  password = null,
}) => {
  if (!token) return;

  setLoading(true);

  try {

    if ((status === 'fillForm' || status === 'edit') && !password) {
      const { isOpen, requiresPassword } = await handleIsOpenForm(id, token);

    
      if (requiresPassword) {
        setPasswordModalOpen(true);
        setFormId(id);
        setLoading(false);
        return;
      }
    
      if (!isOpen) {
        setLoading(false);
        return; 
      }
    }
    

    const url = password
      ? `https://formmaker-api.altynlogistics.com/api/form/${id}?password=${encodeURIComponent(password)}`
      : `https://formmaker-api.altynlogistics.com/api/form/${id}`;

    const response = await axios.get(url);
    
    if(response.data.errors[0]){
      toast(<CustomToast message={response.data.errors[0]} state={'error'} />);
      return
    }

    const { content } = response.data.output;
    const parsedForms = JSON.parse(content.forms);


    if (!parsedForms?.sendToServerData) {
      setError('Form data is incomplete');
      return;
    }

    setFormFullDetails(parsedForms);
    setDrawerData(parsedForms.sendToServerData);
    setTitle(content.title);
    setEditMode(true);

    if (status === 'edit') {
      navigate(`/build/${id}`);
    } else {
      navigate(`/user/fill-form/${id}`);
      localStorage.setItem('FormId', id);
    }
  } catch (err) {
    setError(err.message || 'An error occurred');
  } finally {
    setLoading(false);
  }
};
